module.exports = __webpack_public_path__ + "img/报名流程.5d280bb7.png";